// extracted by mini-css-extract-plugin
export default {"header":"t_rJ1","emailFromContainer":"oRAuc","emailFrom":"VOexh","date":"qb0FS","content":"G2tmL","answer":"c_W0z","answerTitle":"ht_Dh","answerText":"U6cRX"};